var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ECEDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 19.5001L17.1429 15.0001M12.8571 15.0001L7.87503 19.5001M7.5 11.2501L13.6237 15.5366C14.1196 15.8838 14.3675 16.0573 14.6372 16.1245C14.8754 16.1839 15.1246 16.1839 15.3628 16.1245C15.6325 16.0573 15.8804 15.8838 16.3763 15.5366L22.5 11.2501M11.1 21.0001H18.9C20.1601 21.0001 20.7902 21.0001 21.2715 20.7548C21.6948 20.5391 22.039 20.1949 22.2548 19.7715C22.5 19.2902 22.5 18.6602 22.5 17.4001V12.6001C22.5 11.3399 22.5 10.7099 22.2548 10.2286C22.039 9.80522 21.6948 9.46101 21.2715 9.2453C20.7902 9.00006 20.1601 9.00006 18.9 9.00006H11.1C9.83988 9.00006 9.20982 9.00006 8.72852 9.2453C8.30516 9.46101 7.96095 9.80522 7.74524 10.2286C7.5 10.7099 7.5 11.3399 7.5 12.6001V17.4001C7.5 18.6602 7.5 19.2902 7.74524 19.7715C7.96095 20.1949 8.30516 20.5391 8.72852 20.7548C9.20982 21.0001 9.83988 21.0001 11.1 21.0001Z",
    stroke: "#106D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.70cc6f129567f82f568e3a06c27b214d.svg";
export { ForwardRef as ReactComponent };